<template>
  <div>
    <div class="text-center mt-2" v-if="!dataLoaded">
      <v-progress-circular :size="50" color="primary" indeterminate />
    </div>

    <div v-show="dataLoaded">
      <v-row class="my-0">
        <v-col cols="8" class="pr-2 py-0">
          <v-card class="base-card holiday-info pa-5" ref="holidayInfo">
            <v-alert type="info" outlined class="body-2 mb-0 mt-5" v-if="isNoHolidays">
              Для данного цикла выходные дни не предусмотрены
            </v-alert>

            <div v-else>
              <h4 class="holiday-info-title">Выходные дни:</h4>

              <p class="no-holiday" v-if="!holidays.datesList.length">
                Выходные дни не выбраны
              </p>

              <div class="holiday-list" v-else>
                <table class="base-table">
                  <tr v-for="holiday in holidays.datesList">
                    <td>{{ holiday | getDateWithMonthName }}</td>
                    <td>{{ holiday | getDayName }}</td>
                    <td>
                      <v-icon
                        color="lightGrey"
                        class="remove"
                        size="22"
                        title="Удалить"
                        @click="removeHoliday(holiday)"
                      >
                        mdi-trash-can-outline
                      </v-icon>
                    </td>
                  </tr>
                </table>
              </div>

              <div class="bottom-space"></div>
            </div>
          </v-card>
        </v-col>

        <v-col cols="4" class="pl-2 py-0">
          <v-card class="base-card pa-3">
            <v-date-picker
              ref="holidayCalendar"
              :value="holidays.datesList"
              :disabled="disabled"
              class="holiday-calendar"
              locale="ru"
              color="primary"
              full-width
              landscape
              no-title
              multiple
              :show-current="false"
              :min="fromDate"
              :max="toDate"
              :first-day-of-week="1"
              :picker-date.sync="startMonth"
              :readonly="isNoHolidays"
              @input="changeHolidaysCalendar"
            />
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { holidayApi } from '@/api'
import { mapGetters } from 'vuex'
import _cloneDeep from 'lodash/cloneDeep'
import { getDateWithMonthName, getDayName } from '@/scripts'
import { CycleHolidays } from '@/models'

export default {
  name: 'Calendar',

  metaInfo: {
    title: 'Календарь'
  },

  props: {
    infoBlockHeight: Number
  },

  async created() {
    await this.getHolidays()
    this.checkCalendarClick()
    this.dataLoaded = true
  },

  mounted() {
    this.setTableHeight()
    window.addEventListener("resize", this.setTableHeight)
  },

  destroyed() {
    window.removeEventListener("resize", this.setTableHeight)
  },

  data: () => ({
    dataLoaded: false,
    startMonth: null,
    limitHolidays: 0,
    disabled: false,

    holidays: new CycleHolidays()
  }),

  computed: {
    ...mapGetters('system', ['techMessageHeight']),
    ...mapGetters('cycle', ['cycleInfo', 'cycleId', 'fromDate', 'toDate']),

    isNoHolidays() {
      // return this.limitHolidays < 1
      return false
    }
  },

  filters: {
    getDayName,
    getDateWithMonthName
  },

  methods: {
    async getHolidays() {
      try {
        // показываем стартовый месяц календаря, равный дате начала цикла
        this.startMonth = this.fromDate

        const data = await holidayApi.getCycleHolidays(this.cycleId)
        this.holidays.buildFromAPI(data)
        this.setLimitHolidays()
      } catch (e) {
        console.log(e.status)
      }
    },

    async saveHolidays(backupDatesList = []) {
      try {
        const data = await holidayApi.sendCycleHolidays(this.cycleId, this.holidays.getForAPI())
        this.holidays.updateDatesList(data)
      } catch (e) {
        this.holidays = backupDatesList
        this.showErrorMessage(e, 'Ошибка сохранения календаря')
      }
    },

    async changeHolidaysCalendar(dates) {
      try {
        this.disabled = true

        // Todo: вернуть, когда будет нормальная логика у людей
        // if (dates.length <= this.limitHolidays) {
        const backupDatesList = _cloneDeep(this.holidays)
        this.holidays.setDatesList(dates)
        await this.saveHolidays(backupDatesList)
        // } else {
        //   this.$toastr('warning', '', `Превышено количество выходных дней.
        //   Максимальное количество выходных дней на данном цикле - ${this.limitHolidays}`)
        // }
      } catch (e) {
        console.log(e.status)
      } finally {
        this.disabled = false
      }
    },

    async removeHoliday(date) {
      const backupDatesList = _cloneDeep(this.holidays)
      this.holidays.removeHoliday(date)
      await this.saveHolidays(backupDatesList)
    },

    setLimitHolidays() {
      const minDate = new Date(this.fromDate)
      const maxDate = new Date(this.toDate)
      const timeDiff = Math.abs(maxDate.getTime() - minDate.getTime())
      const cycleDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1

      const cycleHours = parseInt(this.cycleInfo.unitId)
      const studyDays = Math.ceil(cycleHours / 8)

      this.limitHolidays = cycleDays - studyDays
    },

    setTableHeight() {
      const otherElements = 211 + this.infoBlockHeight + this.techMessageHeight

      if (this.$refs?.holidayInfo) {
        this.$refs.holidayInfo.$el.style.maxHeight = window.innerHeight - otherElements + 'px'
      }
    },

    // если календарь read-only, то клики по нему не вызывают событий, значит слушаем их нативно
    checkCalendarClick() {
      // Todo: если будет опять ридонли календарь, то выводит какое-то сообщение
      // const calendar = this.$refs.holidayCalendar.$el
      //
      // if (calendar) {
      //   calendar.addEventListener('click', e => {
      //     if (e.target.classList.contains('v-btn__content')) {
      //       this.$toastr('warning', '', ``)
      //     }
      //   })
      // }
    }
  },

  watch: {
    infoBlockHeight() {
      this.setTableHeight()
    }
  }
}
</script>

<style scoped>
/* область внизу карточки, чтобы визуально везде был padding */
.base-card .bottom-space {
  position: sticky;
  bottom: 0;
  height: 20px;
  width: 100%;
  background-color: #fff;
}

.holiday-calendar >>> .v-date-picker-table--date {
  padding-left: 0;
  padding-right: 0;
}

.holiday-calendar >>> .v-date-picker-header {
  padding: 0 8px;
}

.holiday-calendar >>> .v-date-picker-header .theme--light.v-btn.v-btn--disabled {
  background-color: #fff !important;
}

.holiday-calendar >>> .v-date-picker-header .theme--light.v-btn.v-btn--disabled .v-icon {
  color: var(--disabled-color) !important;
}

.holiday-calendar >>> .v-date-picker-table {
  height: 248px;
}

.holiday-calendar >>> .v-date-picker-table th {
  color: var(--accent-color) !important;
}

.holiday-calendar >>> .theme--light.v-btn {
  color: var(--accent-color) !important;
}

.holiday-calendar >>> .theme--light.v-btn.v-btn--disabled {
  color: var(--disabled-color) !important
}

.holiday-calendar >>> .theme--light.v-btn.v-btn--active {
  color: #fff !important
}

.holiday-calendar >>> .v-date-picker-header__value button {
  color: var(--accent-color) !important;
}

.holiday-info {
  color: var(--accent-color) !important;
  min-height: 312px;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  overflow-y: auto;
}

.holiday-info-title {
  position: sticky;
  line-height: 1;
  padding-top: 20px;
  padding-bottom: 20px;
  top: 0;
  z-index: 1;
  background-color: #fff;
}

.no-holiday {
  margin-bottom: 0;
  margin-top: 6px;
  font-size: 15px;
}

.holiday-list table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
}

.holiday-list table tr td {
  border-bottom: 1px solid var(--separator-color);
  padding: 7px 0;
}

.holiday-list table tr:last-child td {
  border-bottom: none;
}

.holiday-list table td:first-child {
  width: 150px;
}

.holiday-list table td:last-child {
  text-align: right;
}

.holiday-list .remove:hover {
  color: var(--error-color) !important;
}
</style>